const publicCN = {
    SEARCH: 'Search',
    COMPANY_SEARCH: 'Company',
    PERSON_SEARCH: 'Company Details',
    COMPANY: 'Company',
    PERSON: 'Person',
    REGISTER: 'Register',
    REGISTER_SUCCEED: 'Register Succeed',
    SEND_SUCCEED: 'Send succeed ！',
    SEND_FAILED: 'Send failed！please retry！',
    MAIL_AL_REGISTER: 'The mail already register',
    LOGIN_AND_REG: 'Login & Register',
    LOGIN: 'Login',
    PLS_INPUT_PWD: 'Please input password',
    PLS_INPUT_EMAIL: 'Please input email',
    PLS_INPUT_RIGHT_EMAIL: 'Please input right email',
    PLS_INPUT_VALIDATE_CODE: 'Please input validate code',
    PLS_INPUT_COMPANY: 'Please input company',
    CONTACT: 'Contact',
    SEARCH_SENTENSE1: 'Browse  database of 60M+ profiles',
    COMPANIES: 'Companies',
    CONTACTS: 'Contacts',
    SEARCH_EMAIL: 'Direct email address',
    SEARCH_PHONE: 'Direct phone number',
    SEARCH_SENTENSE2: 'Company name,product keywords.',
    SEARCH_SENTENSE3: 'Company name',
    SEARCH_SENTENSE4: "Cearch keyword can't be empty.",
    SEARCH_SENTENSE5: "Get direct contact, emails, phone of your next customer ",
    NAME: 'Name',
    CHINESE: 'Chinese',
    ENGLISH: 'English',
    COLLECT: 'Favorite',
    CLEAR: 'Clear',
    KEYWORD: 'Keyword',
    COUNTRY: 'Country',
    INDUSTRY: 'Industry',
    REVENUE: 'Revenue',
    EMPLOYEE: 'Employees',
    EMPLOYEE_U: 'Employee',
    RESULT: 'Result for',
    SELECTALL: 'Select all',
    EXPORT: 'Export to',
    SORTBY: 'Sort by:',
    SUMMARY: 'Summary',
    NEWS: 'News',
    SOCIAL: 'Social',
    TRADERECORD: 'Trade record',
    WEBSITE: 'Website',
    TYPE: 'Company type',
    EMPLOYEES: 'Employees',
    ESTABLISHED: 'Established',
    PHONE: 'Phone',
    FAX: 'Fax',
    ADDRESS: 'Address',
    CONTACT_LEVEL: 'Contact Level',
    CONTACT_ROLE: 'Contact Role',
    LEVEL_ROLE: 'Level&Role',
    CONTACT_WAY: 'Contact',
    MANAGE: 'Manage',
    CHECK: 'Check',
    CHECKED: 'Checked',
    SOCIAL_INFO: 'Social Infos',
    JOB_TITLE: 'Job title',
    MY: 'my',
    AND: '&',
    ALL: 'ALL',
    ENTER_A_KEYWORD: 'Enter a keyword',
    SELECT_A_LOCATION: 'Select a location',
    SELECT_A_INDUSTRY: 'Select a industry',
    ENTER_A_COMPANY: 'Enter a company name',
    ENTER_A_NAME: 'Enter a Name',
    SELECT_A_JOB_LEVEL: 'Select a job level',
    SELECT_A_JOB_FUNCTION: 'Select a job function',
    EMAIL_ADDRESS: 'Email Address',
    IDENTIFY_CODE: 'Identify code',
    SEARCH_SENTENSE6: 'Please input  password',
    SEARCH_SENTENSE7: 'Please input email address',
    SEARCH_SENTENSE8: 'Please input address',
    SEARCH_SENTENSE9: 'Please input company',
    SEARCH_SENTENSE10: 'Please input identify',

}
export default publicCN


// WEBPACK FOOTER //
// ./src/lan/en/en_public.js